export default [
  {
    path: '/home',
    name: 'dashboard-admin',
    component: () => import('@/views/home/dashboard/analytics/Analytics.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Index',
          active: true,
        },
      ],
    },
  },
  {
    path: '/home',
    name: 'home-dashboard',
    component: () => import('@/views/home/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard-internal',
    component: () => import('@/views/home/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard/sparing',
    name: 'dashboard-sparing',
    component: () => import('@/views/home/dashboard/Sparing.vue'),
  },
  {
    path: '/dashboard/sparing-rpsm',
    name: 'dashboard-sparing-rpsm',
    component: () => import('@/views/home/dashboard/SparingRPSM.vue'),
  },
  {
    path: '/dashboard/sparing-internal',
    name: 'dashboard-sparing-internal',
    component: () => import('@/views/home/dashboard/SparingInternal.vue'),
  },
  {
    path: '/dashboard/air-quality',
    name: 'dashboard-air-quality',
    component: () => import('@/views/home/dashboard/AirQuality.vue'),
  },
  {
    path: '/dashboard/sparingtv',
    name: 'dashboard-sparing-tv',
    component: () => import('@/views/home/dashboard/Sparingtv.vue'),
    meta: {
      pageTitle: 'Dashboard',
      navActiveLink: 'dashboard-sparing',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Sparing TV',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/sparingtv-rpsm',
    name: 'dashboard-sparing-tv-rpsm',
    component: () => import('@/views/home/dashboard/SparingtvRPSM.vue'),
    meta: {
      pageTitle: 'Dashboard',
      navActiveLink: 'dashboard-sparing',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Sparing TV',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/sparing2',
    name: 'dasboard-sparing-all',
    component: () => import('@/views/home/dashboard/Sparing2.vue'),
  },
  {

    path: '/dashboard/temperature',
    name: 'dashboard-temperature',
    component: () => import('@/views/home/dashboard/Temperature.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          to: '/dashboard',
        },
        {
          text: 'Temperature',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/monitoring',
    name: 'dashboard-monitoring',
    component: () => import('@/views/home/dashboard/Monitoring.vue'),
    meta: {
      pageTitle: 'Monitoring',
      breadcrumb: [
        {
          text: 'Home',
        },
        {
          text: 'Monitoring',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/Report',
  //   name: 'Laporan',
  //   component: () => import('@/views/home/dashboard/Report.vue'),
  // }
]
